var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bookingBox"},[_c('div',[_vm._v(_vm._s(_vm.hotelBooking.name))]),_c('div',[_vm._v("จำนวนห้อง: "+_vm._s(_vm.hotelBooking.rooms))]),_c('div',[_vm._v("วันที่จอง: "+_vm._s(_vm.hotelBooking.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }